exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-57d67a7f]{\n  width: 300px;\n}\n.color_red[data-v-57d67a7f]{\n  color:#F5222D;\n}\n.color_green[data-v-57d67a7f]{\n  color:#7ABE5C;\n}\n", ""]);

// exports
